exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".placeholder {\n  background-color: gray;\n  position: relative;\n  text-align: center;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center; }\n\n.info {\n  color: white; }\n\nimg {\n  max-width: 100%;\n  max-height: 200px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/app/shared/modules/input-image/input-image.component.scss
// module id = 488
// module chunks = 8 12 13 14 15 16 17 18 19